<template> 
<p  @click="check">
  <span v-html="output" v-if="!hastooltip"></span>
  <span v-html="output" v-if="hastooltip && !showExpand" class="show-pointer"></span>
  <span v-html="tooltiptext" v-if="hastooltip && showExpand"  class="show-pointer"></span>
</p>  
</template>

<script>
export default {
  props:["data","column"],
  name: '"AnalyticsListOutputCell"',
  computed:{
  	output()
  	{
      
  		if(this.data || this.data===0)
  		{  	
        if(!this.column.filteroptions)
        {
          return this.data
        }
        //custom_attribute	
        if(this.column.filteroptions.type=="custom_attribute")
        {
          
          if(this.column.customattribute)
          {
            if(this.column.customattribute.type=="select"
              ||this.column.customattribute.type=="boolean"
              ||this.column.customattribute.type=="categorised"
              ||this.column.customattribute.type=="cascadecategorised")
            {
              let option = this.column.filterselectors.find(item=>item.id == this.data)
              if(option)
              {
                return this.getTheTranslation(option,"translation")
              }
            }
            else
            {
              return this.data
            }
          }
          else
          {
            return '<i class="pi pi-times-circle text-red-500"></i>'
          }
        }
        //custom_attribute
        //numerical  
        if(this.column.filteroptions.type=="questionlist_nonconformity_count" 
          || this.column.filteroptions.type=="section_nonconformities" 
          || this.column.filteroptions.type=="inputfield_nonconformity_count"
          || this.column.filteroptions.type=="verification_auditor"
          || this.column.filteroptions.type=="audit_auditor"
          || this.column.filteroptions.type=="supplier_location"
          || this.column.filteroptions.type=="supplier_users"
          || this.column.filteroptions.type=="last_supplier_conversation" )
        {
          return this.data
        }
        //numerical 
        //numerical  
        if(this.column.filteroptions.type=="questionlist_points" 
          || this.column.filteroptions.type=="questionlist_custom_points" 
          || this.column.filteroptions.type=="section_points" 
          || this.column.filteroptions.type=="inputfield_point" )
        {
          
          return this.$filters.numberformatwithdigits( this.data,3)
        }
        //numerical 
        //date  
        if(this.column.filteroptions.type=="verification_date" 
          || this.column.filteroptions.type=="audit_date" )
        {
          return this.$filters.momentFormat( this.data," Do-MM-YYYY")
        }
        //date
        //note  
        if(this.column.filteroptions.type=="inputfield_auditor_note" 
          || this.column.filteroptions.type=="inputfield_supplier_note" )
        {
          return this.data
        }
        //note 
        //project_status  
        if(this.column.filteroptions.type=="project_status" || this.column.filteroptions.type=="flow_status" || this.column.filteroptions.type=="verification_status" || this.column.filteroptions.type=="audit_status")
        {
          let option = this.column.filterselectors.find(item=>item.id == this.data)
          if(option)
          {
            return this.getTheTranslation(option,"translation")
          }
        }
        //project_status  
        //inputfield_null_reason  
        if(this.column.filteroptions.type=="inputfield_null_reason")
        {
          let option = this.column.filterselectors.find(item=>item.id == this.data)
          if(option)
          {
            return this.getTheTranslation(option,"translation")
          }
        }
        //inputfield_null_reason
        //inputfield_submission  
        if(this.column.filteroptions.type=="inputfield_submission")
        {
          
          //has options
          if(this.column.filterselectors)
          {
            //select
            if(this.column.filteroptions.filtertype=="select")
            {
              let option = this.column.filterselectors.find(item=>item.id == this.data)
              if(option)
              {
                return this.getTheTranslation(option,"translation")
              }
              else
              {
                return this.$filters.numberformat( this.data)
              }
            }
            //select
            //multiselect
            else if(this.column.filteroptions.filtertype=="multiselect" || this.column.filteroptions.filtertype=="listselect")
            {
              let selections = JSON.parse(this.data)
              let options = []
              for(let selection of selections)
              {
                let option = this.column.filterselectors.find(item=>item.id == selection)
                if(option)
                {
                  options.push(this.getTheTranslation(option,"translation"))
                }
              }
              
              if(options.length>2)
              {
                
                this.hastooltip = true
                let tooltiptext = ""
                {
                  for (let i = 0; i < options.length; i++) 
                  {
                    if(i==options.length)
                    {
                      tooltiptext = tooltiptext+options[i]
                    }
                    else
                    {
                      tooltiptext = tooltiptext+options[i]+"</br>"
                    }
                  }
                }
                this.tooltiptext = tooltiptext
                return  options[0]+" +"+(options.length-1)
              }
              else
              {
                return  options[0]
              }              
            }
            //multiselect
            //listselect
            //none
            else
            {
              return this.$filters.numberformat( this.data)
            }
            
          }
          //has options
          else
          {
            if(this.column.filteroptions.filtertype=="text" || this.column.filteroptions.filtertype=="longtext")
            {
              if(this.data.length>130)
              {
                this.hastooltip = true
                this.tooltiptext = this.data
                return this.data.substring(0, 130)+"..."
              }
              else
              {
                return this.data
              }
            }
            else
            {
              return this.$filters.numberformat( this.data)
            }
            
          }
          
        }
        //inputfield_submission




  			
  		}
  		return '<i class="pi pi-times-circle text-red-500"></i>'
  	}
  },
  data () {
    return {
      hastooltip:false,
      tooltiptext:null,
      showExpand:false
    }
  },
  methods:{
    check()
    {
      console.log(this.data)
      console.log(this.column)
      console.log(this.output)
      this.showExpand = !this.showExpand
    }
  }
}
</script>

<style lang="css" scoped>
  .show-pointer:hover{
    cursor: pointer;
    opacity: 0.9;
  }
</style>